<script setup>
defineProps({
  visible: Boolean
});

defineEmits(['close']);
</script>

<template>
  <div v-if="visible" class="fixed top-10 right-0 bottom-5 left-0 z-[10000] flex flex-col items-center justify-start gap-5 overflow-y-auto bg-white p-5" @click.stop>
    <h1 class="text-xl font-medium text-[#333]">{{ $t("scan.how") }}</h1>
    <div class="flex flex-col gap-2.5 text-lg text-black/80">
      <h2 class="font-medium text-black/80">{{ $t("scan_instruction.how_title") }}</h2>
      <p class="font-normal text-black/80">{{ $t("scan_instruction.how_description") }}</p>
      <img src="../assets/3rd_qr.png" alt="qr" class="w-full max-w-25 m-auto" />
    </div>
    <div class="flex flex-col gap-2.5 text-lg text-black/80">
      <h2 class="font-medium ">{{ $t("scan.how") }}?</h2>
      <ul class="font-normal list-disc list-outside pl-5">
        <li class="pl-2">{{ $t("scan.tips.one") }}</li>
        <li class="pl-2">{{ $t("scan.tips.two") }}</li>
        <li class="pl-2">{{ $t("scan.tips.three") }}</li>
        <li class="pl-2">{{ $t("scan.tips.four") }}</li>
        <li class="pl-2">{{ $t("scan.instruction") }}.</li>
      </ul>
      <img src="../assets/screenInstruction.png" alt="qr" class="w-full max-w-60 m-auto" />
      <p class="font-normal">{{ $t("scan_instruction.the_scan_will_be") }}</p>
    </div>
    <button class="rounded bg-(--primary) p-2.5 mb-10 text-lg font-bold text-(--text-button)" @click.stop="$emit('close')">
      {{ $t("scan.start_scan") }}
    </button>
  </div>
</template>

<style scoped>

</style>